import { DSTabs, DSTab, DSTabWithSchema, DSTabsWithSchema } from '@elliemae/ds-tabs';
import type { DSTabsT, DSTabT } from '@elliemae/ds-tabs';

type DSMobileTabsPropsT = Omit<
  DSTabsT.Props,
  'animated' | 'enableMouseEvents' | 'allowTextSelection' | 'type' | 'isDSMobile' | 'withCarousel'
>;

type DSMobileTabPropsT = Omit<DSTabT.Props, 'isDSMobile'>;

const DSMobileTabs = (props: DSMobileTabsPropsT) => <DSTabs {...props} isDSMobile />;

const DSMobileTab = (props: DSMobileTabPropsT) => <DSTab {...props} />;

DSMobileTab.displayName = 'DSMobileTab';
const DSMobileTabsWithSchema = DSTabsWithSchema;
const DSMobileTabWithSchema = DSTabWithSchema;

export { DSMobileTabsWithSchema, DSMobileTabWithSchema, DSMobileTabs, DSMobileTab };
